import { useMemo } from 'react'
import { useAccountBalances } from '../../store/account/hooks'
import { useExternalPrices, useMarketIndexes } from '../../store/market/hooks'
import { Wei } from '../../types'
import { calcSpotValueByExternalPrices } from '../../utils/valuation/calcTotalSpotAvailableValue'

/**
 * Calculates the total spot available value based on the account balances and market indexes.
 * @returns The total spot available value.
 */
export function useTotalSpotAvailableValue(): Wei {
  const balances = useAccountBalances()
  const indexes = useExternalPrices()
  return useMemo(() => {
    return calcSpotValueByExternalPrices(balances, indexes)
  }, [balances, indexes])
}
